module.exports = __webpack_public_path__ + "static/oxfordwaitresses-8297fb6bda885b736e8f7929bd1a1c16.jpg";